// zoom-carousel.js
document.addEventListener('DOMContentLoaded', function(){
    if (!window.Swiper) return;
  
    document.querySelectorAll('.zoom-carousel .swiper-container').forEach(function(el){
      var slides = el.querySelectorAll('.swiper-slide').length;
      var desktopMax = 3;
      var loopMode   = slides > desktopMax;
  
      new Swiper(el, {
        centeredSlides: true,
        loop: loopMode,
        watchSlidesProgress: true,
        effect: 'slide',
       
        navigation: {
          nextEl: el.parentNode.querySelector('.swiper-button-next'),
          prevEl: el.parentNode.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          // MOBILE: 1.2 so you peek both prev & next
          0:    { slidesPerView: 1.8, spaceBetween: 16 },
          // TABLET: a little more sneak
          640:  { slidesPerView: 3, spaceBetween: 16 },
          // SMALL DESKTOP: two full bottles
          768:  { slidesPerView: 3,   spaceBetween: 24 },
          // DESKTOP+: up to 3
          1024: { slidesPerView: 3,   spaceBetween: 40 }
        }
      });
    });
  });